import React from 'react'
import {
  PieChart as PieRecharts, Pie, Cell
} from 'recharts';
import { useViewport, viewportBreakpoint } from '../../utils';

const PieChart = ({data, total, colors}) => {
  const { width } = useViewport()
  const breakpoint = viewportBreakpoint.tablet
  const isMobile = width < breakpoint
  const size = isMobile ? 60 : 60

  return (
    <div>
      <PieRecharts width={size} height={size}>
        <Pie
          data={data}
          cx={size/2.2}
          cy={size/2.2}
          // innerRadius={size/2.6}
          outerRadius={size/2.1}
          fill="#8884d8"
          paddingAngle={2}
          dataKey="value"
        >
          {
            data.map((entry, index) => <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />)
          }
        </Pie>
      </PieRecharts>
      </div>
  )
}

export { PieChart }